<section class="clickthrough-container" (click)="openClickThrough()">
  @if (displayVideo) {
    <app-media-chrome-player [src]="videoSources" [loop]="false" [muted]="false" (ended_event)="onVideoEnded()"></app-media-chrome-player>
  }

  <div class="link-url" style="position: absolute; bottom: 0; left: 0">
    @if (callToAction) {
      <div class="action-label">{{ callToAction }}</div>
    } @else {
      {{ domain_name }}
    }
    <mat-icon style="margin-left: 0.4rem">open_in_new</mat-icon>
  </div>
</section>
<button mat-icon-button (click)="cancel()" class="close-button"><mat-icon>close</mat-icon></button>
@if (current_ad.watch_seconds_before_skip) {
  <div class="skip-container">
    @if (!can_skip) {
      <div>{{ count_down_text }}</div>
    }
    @if (can_skip) {
      <button (click)="nextVideo()">Skip</button>
    }
  </div>
}
@if (!current_ad.watch_seconds_before_skip && count_down >= 0) {
  <div class="skip-container">
    <div>{{ count_down }}</div>
  </div>
}
